import { RelocationOrderStatus } from "@/api-schema-enums";

export const RELOCATION_ORDER_STATUS_TRANSLATIONS = {
  [RelocationOrderStatus.TransportCompanyAwaitingPickupDate]: "fit:TransportCompanyAwaitingPickupDate",
  [RelocationOrderStatus.TransportCompanyAwaitingReadyForTransport]: "fit:TransportCompanyAwaitingReadyForTransport",
  [RelocationOrderStatus.BranchAwaitingPickup]: "fit:BranchAwaitingPickup",
  [RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle]: "fit:TransportCompanyRejectedDamagedVehicle",
  [RelocationOrderStatus.TransportCompanyRejectedMissingKeys]: "fit:TransportCompanyRejectedMissingKeys",
  [RelocationOrderStatus.TransportCompanyRejectedMissingVehicle]: "fit:TransportCompanyRejectedMissingVehicle",
  [RelocationOrderStatus.TransportCompanyInTransit]: "fit:TransportCompanyInTransit",
  [RelocationOrderStatus.TransportCompanyRestAtLayover]: "fit:TransportCompanyRestAtLayover",
  [RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance]: "fit:TransportCompanyAwaitingDeliveryAcceptance",
  [RelocationOrderStatus.BranchRejectedDamagedVehicle]: "fit:BranchRejectedDamagedVehicle",
  [RelocationOrderStatus.BranchRejectedMissingKeys]: "fit:BranchRejectedMissingKeys",
  [RelocationOrderStatus.BranchRejectedMissingVehicle]: "fit:BranchRejectedMissingVehicle",
  [RelocationOrderStatus.BranchRejectedWrongVehicle]: "fit:BranchRejectedWrongVehicle",
  [RelocationOrderStatus.Completed]: "fit:Completed",
  [RelocationOrderStatus.Cancelled]: "fit:Cancelled",
} satisfies Record<RelocationOrderStatus, string>;
